"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RT = void 0;
var launchdarkly_js_client_sdk_1 = require("launchdarkly-js-client-sdk");
var js_logger_1 = __importDefault(require("js-logger"));
js_logger_1.default.useDefaults();
var RT = /** @class */ (function () {
    /**
     * This is a class which initializes LaunchDarkly's Client.
     *
     * @param clientId - Client ID for the sdk
     * @param user - User Details for flag evaluation
     * @param config - (optional) Configurations to the sdk (streaming, bootstrap, etc.,)
     */
    function RT(clientId, user, config) {
        try {
            this.client = (0, launchdarkly_js_client_sdk_1.initialize)(clientId, user, config);
        }
        catch (err) {
            var error = {
                sdkKey: process.env.LD_SDK_KEY || 'Client ID undefined',
                message: 'Error in LD Client Initialization : ' + err,
            };
            js_logger_1.default.error(JSON.stringify(error));
        }
    }
    /**
     * Determines the toggle state of a feature flag for a user.
     *
     * @param flag
     *   The unique key of the feature flag.
     * @param defaultValue
     *   The default value of the flag, to be used if the value is not available from LaunchDarkly.
     * @returns
     *   It returns a promise with the variation of a feature flag for a user. It can be `boolean,string,number or JSON`.
     *   Incase if there is any issue in toggle evaluation,default value provided will be returned.
     */
    RT.prototype.toggleState = function (flag, defaultValue) {
        try {
            if (this.client) {
                var ldclient_1 = this.client;
                return ldclient_1.waitForInitialization().then(function () {
                    return ldclient_1.variation(flag, defaultValue);
                })
                    .catch(function (err) {
                    var error = {
                        flagKey: flag,
                        message: 'Error in toggleState : ' + err,
                    };
                    js_logger_1.default.error(JSON.stringify(error));
                    return defaultValue;
                });
            }
            else {
                var error = {
                    message: 'Error in togglestate in LD Client undefined',
                };
                js_logger_1.default.error(JSON.stringify(error));
                return defaultValue;
            }
        }
        catch (err) {
            var error = {
                message: 'Error in togglestate in LD Client Initialization: ' + err,
            };
            js_logger_1.default.error(JSON.stringify(error));
            return defaultValue;
        }
    };
    /**
     * Builds an object that encapsulates the state of all feature flags.
     * This method does not send analytics events back to LaunchDarkly.
     * @returns
     *   It returns a promise with the snapshot of all feature flag values.
     */
    RT.prototype.allFlags = function () {
        try {
            if (this.client) {
                var ldclient_2 = this.client;
                return ldclient_2.waitForInitialization().then(function () {
                    return ldclient_2.allFlags();
                })
                    .catch(function (err) {
                    var error = {
                        message: 'Error in all Flags: ' + err,
                    };
                    js_logger_1.default.error(JSON.stringify(error));
                    return Promise.resolve({});
                });
            }
            else {
                var error = {
                    message: 'Error in allFlags in LD Client undefined',
                };
                js_logger_1.default.error(JSON.stringify(error));
                return Promise.resolve({});
            }
        }
        catch (err) {
            var error = {
                message: 'Error in  allFlags in LD Client Initialization: ' + err,
            };
            js_logger_1.default.error(JSON.stringify(error));
            return Promise.resolve({});
        }
    };
    /**
     * Registers an event listener.
     * The following event names (keys) are used by the client:
     *
     * - "ready": The client has finished starting up. This event will be sent regardless of whether it successfully
     * connected to LaunchDarkly, or encountered an error and had to give up; to distinguish between these cases,
     * see below.
     *
     * - "initialized": The client successfully started up and has valid feature flag data. This will always be
     * accompanied by "ready".
     *
     * - "failed": The client encountered an error that prevented it from connecting to LaunchDarkly, such as an invalid
     * environment ID. All flag evaluations will therefore receive default values. This will always be accompanied
     * by "ready".
     *
     * - "error": General event for any kind of error condition during client operation. The callback parameter is an
     * Error object. If you do not listen for "error" events, then the errors will be logged with console.log().
     *
     * - "change": The client has received new feature flag data. This can happen either because you have switched users
     * with identify, or because the client has a stream connection and has received a live change to a flag value (see
     * below). The callback parameter is an LDFlagChangeset.
     *
     * - "change:FLAG-KEY": The client has received a new value for a specific flag whose key is FLAG-KEY. The callback
     * receives two parameters: the current (new) flag value, and the previous value. This is always accompanied by a
     * general "change" event as described above; you can listen for either or both.
     *
     * The "change" and "change:FLAG-KEY" events have special behavior: by default, the client will open a streaming
     * connection to receive live changes if and only if you are listening for one of these events.
     *
     * @param event
     *   The name of the event for which to listen.
     * @param callback
     *   The function to execute when the event fires. The callback may or may not receive parameters, depending on
     *   the type of event.
     * @returns void
     */
    RT.prototype.on = function (event, callback) {
        try {
            var ldclient = this.client;
            if (ldclient) {
                ldclient.on(event, callback);
            }
            else {
                js_logger_1.default.error("Can't access .on eventHandler. Client is not initialized");
            }
        }
        catch (err) {
            var error = {
                message: "Can't access .on eventHandler: " + err,
            };
            js_logger_1.default.error(JSON.stringify(error));
        }
    };
    /**
    * This method discards all network connections, background tasks,
    * and other resources held by the client. Do not attempt to use
    * the client after calling this method.
    * @returns void
    */
    RT.prototype.close = function () {
        try {
            var ldclient = this.client;
            if (ldclient) {
                ldclient.close();
            }
            else {
                js_logger_1.default.error("Can't close client. Client is not initialized");
            }
        }
        catch (err) {
            var error = {
                message: "Can't close client: " + err,
            };
            js_logger_1.default.error(JSON.stringify(error));
        }
    };
    return RT;
}());
exports.RT = RT;
//# sourceMappingURL=action.js.map